/* eslint-disable max-len */
import 'react';

const MoreHeaderSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M7.333 11C6.6 11 6 11.6 6 12.333c0 .734.6 1.334 1.333 1.334.734 0 1.334-.6 1.334-1.334 0-.733-.6-1.333-1.334-1.333zm9.334 0c-.734 0-1.334.6-1.334 1.333 0 .734.6 1.334 1.334 1.334.733 0 1.333-.6 1.333-1.334C18 11.6 17.4 11 16.667 11zM12 11c-.733 0-1.333.6-1.333 1.333 0 .734.6 1.334 1.333 1.334s1.333-.6 1.333-1.334c0-.733-.6-1.333-1.333-1.333z"
                fill="#5C6373"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default MoreHeaderSvg;
